import React from 'react';
import './Waves.sass'
import {useMediaQuery, useTheme} from "@mui/material";

function Waves({pos, halfCover=false}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={`ocean ocean_${pos} ${halfCover && 'ocean_half_cover'}`}>
            <div className={`wave ${isMobile && 'wave_mobile'}`} />
            <div className={`wave ${isMobile && 'wave_mobile'}`} />
        </div>
    );
}

export default Waves;